(function () {
  const ACCESS = new Set([
    'SIGN_IN_REQUIRED',
    'MEMBERSHIP_REQUIRED',
    'MEMBERSHIP_SYNC_PENDING',
    'ENTITLED',
    'ENTITLEMENT_UNAVAILABLE',
  ]);
  const MEMBERSHIP_URL = 'https://shop.funnyhooks.com/products/funnyhooks-membership';

  function presentationFor(result) {
    if (result.access === 'MEMBERSHIP_REQUIRED') {
      if (!Object.prototype.hasOwnProperty.call(result, 'presentation') && result.purchaseTarget === MEMBERSHIP_URL) return 'NEVER_MEMBER';
      if (result.presentation === 'NEVER_MEMBER' || result.presentation === 'FORMER_MEMBER') return result.presentation;
    }
    if (result.access === 'MEMBERSHIP_REQUIRED' || result.access === 'MEMBERSHIP_SYNC_PENDING') {
      if (result.presentation === 'CANCELLED_WITH_UNKNOWN_PAID_THROUGH' || result.presentation === 'PAUSED_WITHOUT_VERIFIED_ENTITLEMENT') return result.presentation;
    }
    if (result.access === 'MEMBERSHIP_SYNC_PENDING' && result.presentation === 'GENUINE_SYNC_PENDING') return result.presentation;
    if (result.access === 'ENTITLEMENT_UNAVAILABLE' && result.presentation === 'ENTITLEMENT_UNAVAILABLE') return result.presentation;
    return 'ACCESS_UNCONFIRMED';
  }

  function setState(root, access, options) {
    const shell = root.querySelector('[data-member-lab-state]');
    const title = root.querySelector('[data-member-lab-state-title]');
    const copy = root.querySelector('[data-member-lab-state-copy]');
    const action = root.querySelector('[data-member-lab-state-action]');
    if (!shell || !title || !copy || !action) return;

    shell.dataset.memberLabState = access;
    title.textContent = options.title;
    copy.textContent = options.copy;
    if (options.actionLabel && options.actionUrl) {
      action.textContent = options.actionLabel;
      action.href = options.actionUrl;
      action.hidden = false;
    } else {
      action.removeAttribute('href');
      action.hidden = true;
    }
  }

  function designerLanguage(root) {
    const shell = root.querySelector('[data-language]');
    const value = shell && shell.dataset ? shell.dataset.language : '';
    const documentLanguage = document.documentElement && document.documentElement.lang ? document.documentElement.lang : '';
    return String(value || documentLanguage || 'en').toLowerCase().slice(0, 2);
  }

  function localizedPagePath(page, suffix) {
    const pathname = window.location && typeof window.location.pathname === 'string' ? window.location.pathname : '';
    const match = pathname.match(/^\/([^/]+)\/pages(?:\/|$)/);
    const prefix = match ? `/${match[1]}` : '';
    return `${prefix}/pages/${page}${suffix || ''}`;
  }

  function ensureDesignerUxStyle() {
    if (!document.getElementById || !document.createElement || !document.head) return;
    if (document.getElementById('fh-member-lab-designer-ux-style')) return;
    const style = document.createElement('style');
    style.id = 'fh-member-lab-designer-ux-style';
    style.textContent = [
      '.fhb__assistant-random[data-bobbel-roulette-ready="true"]{text-align:left}',
      '.fhb__assistant-random .fhb__roulette-copy{display:block;margin-top:6px;font-weight:400;line-height:1.45}',
      '.fhb__assistant-random .fhb__roulette-cta{display:inline-block;margin-top:12px;font-weight:800;text-decoration:underline;text-underline-offset:.18em}',
      '.fh-member-lab__designer-nav{display:flex;flex-wrap:wrap;gap:10px 12px;align-items:center;padding-top:12px;padding-bottom:10px}',
      '.fh-member-lab__designer-nav .button{margin:0;min-height:42px}',
    ].join('');
    document.head.appendChild(style);
  }

  function decorateBobbelDesigner(root) {
    ensureDesignerUxStyle();
    const german = designerLanguage(root) === 'de';
    const random = root.querySelector('[data-assistant-random-bobbel]');
    if (random && random.dataset.bobbelRouletteReady !== 'true') {
      const title = document.createElement('strong');
      const copy = document.createElement('span');
      const cta = document.createElement('span');
      title.textContent = 'Bobbel-Roulette';
      copy.className = 'fhb__roulette-copy';
      copy.textContent = german
        ? 'Roulette. Nur dass du nie verlierst. FunnyHooks eben.'
        : 'Roulette. You just never lose. FunnyHooks style.';
      cta.className = 'fhb__roulette-cta';
      cta.textContent = german ? 'Na dann.' : 'Well then.';
      random.replaceChildren(title, copy, cta);
      random.dataset.bobbelRouletteReady = 'true';
    }

    const nav = root.querySelector('[data-member-lab-designer] > .page-width');
    if (nav && nav.dataset.designerNavReady !== 'true') {
      const back = document.createElement('a');
      back.className = 'button button--secondary';
      back.href = localizedPagePath('member-lab');
      back.textContent = german ? '← Zurück zum Member Lab' : '← Back to Member Lab';

      const oracle = document.createElement('a');
      oracle.className = 'button';
      oracle.dataset.bobbelDesignerOracleLink = '';
      oracle.href = localizedPagePath('member-lab', '?oracle=bobbel-designer#member-lab-oracle');
      oracle.textContent = german ? 'Zum Wollorakel →' : 'To the Wollorakel →';

      nav.classList.add('fh-member-lab__designer-nav');
      nav.replaceChildren(back, oracle);
      nav.dataset.designerNavReady = 'true';
    }
  }

  function loadDesigner(root) {
    const shell = root.querySelector('[data-member-lab-state]');
    const designer = root.querySelector('[data-member-lab-designer]');
    const source = root.dataset.designerSrc || '';
    if (!designer || !source) return;

    decorateBobbelDesigner(root);
    if (shell) shell.hidden = true;
    designer.hidden = false;
    root.dataset.memberLabResolved = 'ENTITLED';

    if (document.querySelector('script[data-member-lab-designer-runtime]')) return;
    const script = document.createElement('script');
    script.src = source;
    script.defer = true;
    script.dataset.memberLabDesignerRuntime = '';
    document.head.appendChild(script);
  }

  function loadMemberLab(root) {
    const shell = root.querySelector('[data-member-lab-state]');
    const content = root.querySelector('[data-member-lab-content]');
    if (shell) shell.hidden = true;
    if (content) content.hidden = false;
    root.dataset.memberLabResolved = 'ENTITLED';
    if (content && typeof window.CustomEvent === 'function') {
      document.dispatchEvent(new window.CustomEvent('member-lab-content-ready', { detail: content }));
    }
  }

  function showDeniedState(root, result) {
    const contactUrl = root.dataset.contactUrl || '/pages/kontakt';
    const presentation = presentationFor(result);
    const retry = root.querySelector('[data-member-lab-retry]');
    if (retry) retry.hidden = true;
    if (presentation === 'NEVER_MEMBER' || presentation === 'FORMER_MEMBER') {
      const former = presentation === 'FORMER_MEMBER';
      setState(root, result.access, {
        title: (former ? root.dataset.formerTitle : '') || root.dataset.gateTitle || root.dataset.designerTitle || 'Bobbel Designer — Mitglieder-Vorschau',
        copy: (former ? root.dataset.formerCopy : '') || root.dataset.membershipRequiredCopy || 'Die Wollgötter verlangen derzeit eine aktive FunnyHooks Membership.',
        actionLabel: (former ? root.dataset.formerLabel : '') || root.dataset.membershipLabel || 'Membership aktivieren',
        actionUrl: MEMBERSHIP_URL,
      });
      return;
    }
    if (presentation === 'GENUINE_SYNC_PENDING') {
      setState(root, result.access, {
        title: root.dataset.syncTitle || 'Fast fertig gewickelt',
        copy: root.dataset.syncCopy || 'Deine Membership wurde erkannt. Der Zugang zum Member Lab wird noch synchronisiert. Bitte versuche es später erneut oder kontaktiere uns.',
        actionLabel: root.dataset.contactLabel || 'Kontakt aufnehmen',
        actionUrl: contactUrl,
      });
      if (retry && root.dataset.memberLabRetryUsed !== 'true') {
        retry.hidden = false;
        retry.onclick = function () {
          if (root.dataset.memberLabRetryUsed === 'true') return;
          root.dataset.memberLabRetryUsed = 'true';
          retry.disabled = true;
          retry.hidden = true;
          initialize(root);
        };
      }
      return;
    }
    const copyKey = presentation === 'CANCELLED_WITH_UNKNOWN_PAID_THROUGH' ? 'cancelledUnknownCopy'
      : presentation === 'PAUSED_WITHOUT_VERIFIED_ENTITLEMENT' ? 'pausedCopy'
        : presentation === 'ENTITLEMENT_UNAVAILABLE' ? 'unavailableCopy' : 'unconfirmedCopy';
    const titleKey = presentation === 'PAUSED_WITHOUT_VERIFIED_ENTITLEMENT' ? 'pausedTitle'
      : presentation === 'ENTITLEMENT_UNAVAILABLE' ? 'unavailableTitle' : 'unconfirmedTitle';
    setState(root, result.access, {
      title: root.dataset[titleKey] || root.dataset.unavailableTitle || 'Das Member Lab macht gerade eine Wickelpause',
      copy: root.dataset[copyKey] || root.dataset.unavailableCopy || 'Dein Zugang konnte gerade nicht sicher geprüft werden. Bitte versuche es später erneut oder kontaktiere uns.',
      actionLabel: root.dataset.contactLabel || 'Kontakt aufnehmen',
      actionUrl: contactUrl,
    });
  }

  async function initialize(root) {
    if (root.dataset.authenticated !== 'true') return;
    const proxyBase = root.dataset.proxyBase || '/apps/fh-bobbel';
    try {
      const response = await fetch(`${proxyBase}/member-lab/entitlement`, {
        method: 'GET',
        headers: { accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
      });
      if (!response.ok) throw new Error('entitlement_unavailable');
      const result = await response.json();
      if (!result || typeof result !== 'object' || !ACCESS.has(result.access)) {
        throw new Error('invalid_entitlement_response');
      }
      if (result.access === 'ENTITLED') {
        if (root.dataset.memberLabGateMode === 'content') loadMemberLab(root);
        else loadDesigner(root);
        return;
      }
      showDeniedState(root, result);
    } catch {
      showDeniedState(root, { access: 'ENTITLEMENT_UNAVAILABLE', presentation: 'ENTITLEMENT_UNAVAILABLE' });
    }
  }

  document.querySelectorAll('[data-member-lab-gate]').forEach(initialize);
})();
